export default "__VITE_ASSET__Ds2iRT6o__"